<!-- table-search.component.html -->
<div class="header-search">
  <nz-input-group [nzSuffix]="suffixIconSearch">
    <input
      style="width: 400px"
      nz-input
      placeholder="Search tables..."
      [(ngModel)]="searchTerm"
      (input)="onSearch()"
      (keydown.enter)="handleEnterKey($event)"
      [nzAutocomplete]="auto"
    />
  </nz-input-group>
  <ng-template #suffixIconSearch>
    <span nz-icon nzType="search"></span>
  </ng-template>
  <nz-autocomplete #auto>
    <nz-auto-option
      *ngFor="let option of filteredTables"
      [nzValue]="option.title"
      [nzLabel]="option.title"
    >
      <div class="search-result-item">
        <div class="table-name" (click)="navigateToTable(option)">
          <div class="table-title">{{ option.title }}</div>
          <div class="table-category">
            {{ option.category || option.parentMenu }}
          </div>
        </div>
        <div class="table-actions">
          <button
            nz-button
            nzType="default"
            nzSize="small"
            nzShape="circle"
            (click)="editTable(option, $event)"
            nz-tooltip
            nzTooltipTitle="Edit Table"
          >
            <span nz-icon nzType="edit"></span>
          </button>
          <button
            nz-button
            nzType="default"
            nzSize="small"
            nzShape="circle"
            (click)="duplicateTable(option, $event)"
            nz-tooltip
            nzTooltipTitle="Duplicate Table"
          >
            <span nz-icon nzType="copy"></span>
          </button>
        </div>
      </div>
    </nz-auto-option>
  </nz-autocomplete>
</div>
